export const AUTH_NAME = '_auth'
